import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Link } from "react-router-dom";


const JLPrimeSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      ref={ref}
      className="relative min-h-[80vh] flex items-center overflow-hidden bg-navy-deep"
      id="unidades"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <div
          className="w-full h-full bg-cover bg-center bg-no-repeat bg-fixed opacity-40"
          style={{ backgroundImage: 'url(/assets/BC3.webp)' }}
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-black/70" /> {/* Overlay escuro com 70% de opacidade */}
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10 py-24">
        <div className="max-w-3xl">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 mb-8"
          >
            <div className="w-2 h-2 rounded-full bg-accent animate-pulse" />
            <span className="text-xs uppercase tracking-[0.3em] text-accent">
              Nova Unidade
            </span>
          </motion.div>

          {/* Title with Gold Gradient */}
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium leading-[1.1] mb-6"
            style={{
              background: 'linear-gradient(135deg, hsl(43, 74%, 63%) 0%, hsl(43, 74%, 53%) 50%, hsl(43, 74%, 43%) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            JL <span className="block sm:inline">Despachante e Escola Náutica</span> chegou em <span className="text-accent">Balneário Camboriú</span>
          </motion.h2>

          <motion.h3
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="font-heading text-2xl sm:text-3xl text-primary-foreground/90 mb-6"
          >
            A Costa que Mais Cresce no Brasil
          </motion.h3>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-lg text-primary-foreground/70 leading-relaxed mb-10 max-w-xl"
          >
            Nossa base em Balneário Camboriú chega para atender
            a demanda crescente do litoral norte catarinense.
            Formação náutica e assessoria documental com a excelência JL,
            agora na cidade que não para.
          </motion.p>

          {/* Features */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="flex flex-wrap gap-4 mb-10"
          >
            {["Escola Náutica", "Despachante", "Assessoria Completa"].map((feature) => (
              <span
                key={feature}
                className="px-4 py-2 text-sm text-primary-foreground/80 border border-primary-foreground/20 rounded-full"
              >
                {feature}
              </span>
            ))}
          </motion.div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Link to="/balneario-camboriu" className="btn-gold px-8 py-4 rounded-lg text-base font-medium text-primary-foreground inline-flex items-center gap-3 group">
              Conhecer a Unidade
              <svg
                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default JLPrimeSection;